/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsDtoSpirisInvoiceRowDto } from './WebApiIntegrationsDtoSpirisInvoiceRowDto';
import {
    WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSON,
    WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSONTyped,
    WebApiIntegrationsDtoSpirisInvoiceRowDtoToJSON,
} from './WebApiIntegrationsDtoSpirisInvoiceRowDto';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
 */
export interface WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    amount?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    memberIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    connectedYear?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    generateAmountFromMembership?: boolean;
    /**
     * Optional Spiris article for the legacy single manual row.
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    articleNumber?: string | null;
    /**
     * Optional invoice due date for the whole run. Null => Spiris default.
     * @type {Date}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    dueDate?: Date | null;
    /**
     * Optional invoice date for the whole run. Null => today.
     * @type {Date}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    invoiceDate?: Date | null;
    /**
     * Invoice lines applied to every selected member (manual mode). When non-empty this is used
     * and the scalar description / amount /
     * ArticleNumber are ignored. Not used when
     * generateAmountFromMembership is true.
     * @type {Array<WebApiIntegrationsDtoSpirisInvoiceRowDto>}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    rows?: Array<WebApiIntegrationsDtoSpirisInvoiceRowDto> | null;
    /**
     * When false (default), members that aren't in Spiris yet are skipped. When true, a Spiris
     * customer is created for them as part of the run.
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto
     */
    createMissingCustomers?: boolean;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDtoFromJSON(json: any): WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto {
    return WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'memberIds': !exists(json, 'memberIds') ? undefined : json['memberIds'],
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
        'generateAmountFromMembership': !exists(json, 'generateAmountFromMembership') ? undefined : json['generateAmountFromMembership'],
        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
        'dueDate': !exists(json, 'dueDate') ? undefined : (json['dueDate'] === null ? null : new Date(json['dueDate'])),
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : (json['invoiceDate'] === null ? null : new Date(json['invoiceDate'])),
        'rows': !exists(json, 'rows') ? undefined : (json['rows'] === null ? null : (json['rows'] as Array<any>).map(WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSON)),
        'createMissingCustomers': !exists(json, 'createMissingCustomers') ? undefined : json['createMissingCustomers'],
    };
}

export function WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDtoToJSON(value?: WebApiIntegrationsDtoCreateMultipleSpirisInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'amount': value.amount,
        'memberIds': value.memberIds,
        'connectedYear': value.connectedYear,
        'generateAmountFromMembership': value.generateAmountFromMembership,
        'articleNumber': value.articleNumber,
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
        'invoiceDate': value.invoiceDate === undefined ? undefined : (value.invoiceDate === null ? null : value.invoiceDate.toISOString()),
        'rows': value.rows === undefined ? undefined : (value.rows === null ? null : (value.rows as Array<any>).map(WebApiIntegrationsDtoSpirisInvoiceRowDtoToJSON)),
        'createMissingCustomers': value.createMissingCustomers,
    };
}

